import httpApi from '@vue3/utils/http-api'
import { api } from '@vue3/configs'

export default {
  getConfig: (query) => {
    return httpApi.getDataViaApi({
      url: api.cmsConfig.getConfig,
      queryParams: query
    })
  },
  getServicesPromotion () {
    return httpApi.getDataViaApi({
      url: api.cmsConfig.getServiceAndPromotion
    })
  }
}
